import httpClient from './index';

const END_POINT = 'api/v1/agent/signup';

const signup = (data) => httpClient.post(`${END_POINT}`, {...data});

export { signup };